import type { EditorDraft } from '@/features/editor/types/editor.types'
import type { KnowledgeEntry } from '@/features/editor/types/knowledge.types'
import { createId } from '@/features/editor/lib/editor-id'
import { normalizeEntry } from '@/features/editor/lib/editor-normalize'

export function createEmptyDraft(engineId: string | null): EditorDraft {
  return {
    engineId,

    title: '',
    description: '',
    tags: [],

    coverImageUrl: '',
    backgroundImageUrl: '',

    narrativeCore: '',
    promptTemplateMode: null,
    firstMessage: '',
  }
}

export function createEmptyEntry(seed?: Partial<KnowledgeEntry>): KnowledgeEntry {
  return normalizeEntry({
    id: seed?.id ?? createId(),
    title: seed?.title ?? '',
    content: seed?.content ?? '',
    enabled: seed?.enabled ?? true,
    retrievalMethod: seed?.retrievalMethod ?? 'prompt',
    keywords: seed?.keywords ?? [],
    keywordOp: seed?.keywordOp ?? 'or',
    isUserCard: seed?.isUserCard ?? false,
    // collapsed 已移除（纯 UI 状态，不进入编辑器模型）
  })
}
